
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors specific to the Payment Initiation product.',
  title: 'Payment Initiation'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Payment errors' subtitle='Errors specific to the Payment Initiation product' mdxType="Header" />
    <h4 {...{
      "id": "payment_blocked"
    }}><strong parentName="h4">{`PAYMENT_BLOCKED`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_BLOCKED' subtitle="The payment was blocked for violating compliance rules." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The payment amount value when calling `}<inlineCode parentName="li">{`/payment_initiation/payment/create`}</inlineCode>{` was too high.`}</li>
        <li parentName="ul">{`Too many payments were created in a short period of time.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Contact your Plaid account manager for your compliance rules.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_cancelled"
    }}><strong parentName="h4">{`PAYMENT_CANCELLED`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_CANCELLED' subtitle='The payment was cancelled.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The payment was cancelled by the user during the authorisation process.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again or choose another institution to initiate a payment.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_insufficient_funds"
    }}><strong parentName="h4">{`PAYMENT_INSUFFICIENT_FUNDS`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_INSUFFICIENT_FUNDS' subtitle="The account has insufficient funds to complete the payment." client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-2"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The account selected has insufficient funds to complete the payment.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-2"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again or choose another account or institution to initiate a payment.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_invalid_recipient"
    }}><strong parentName="h4">{`PAYMENT_INVALID_RECIPIENT`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_INVALID_RECIPIENT' subtitle='The recipient was rejected by the chosen institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-3"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The recipient name is too long or contains special characters.`}</li>
        <li parentName="ul">{`The address is too long or contains special characters.`}</li>
        <li parentName="ul">{`The account number is invalid.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-3"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different recipient.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Create a new recipient with a shorter name and address and/or without special characters.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_invalid_reference"
    }}><strong parentName="h4">{`PAYMENT_INVALID_REFERENCE`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_INVALID_REFERENCE' subtitle='The reference was rejected by the chosen institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-4"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The reference is too long or contains special characters.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-4"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different reference.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_invalid_schedule"
    }}><strong parentName="h4">{`PAYMENT_INVALID_SCHEDULE`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_INVALID_SCHEDULE' subtitle='The schedule was rejected by the chosen institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-5"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The chosen institution does not support negative payment execution days.`}</li>
        <li parentName="ul">{`The first payment date is a holiday or on a weekend.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-5"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different schedule.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_rejected"
    }}><strong parentName="h4">{`PAYMENT_REJECTED`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_REJECTED' subtitle='The payment was rejected by the chosen institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-6"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The amount was too large.`}</li>
        <li parentName="ul">{`The payment was considered suspicious by the institution.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-6"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with different payment parameters.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_scheme_not_supported"
    }}><strong parentName="h4">{`PAYMENT_SCHEME_NOT_SUPPORTED`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_SCHEME_NOT_SUPPORTED' subtitle='The requested payment scheme is not supported by the chosen institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-7"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The payment scheme specified when calling `}<inlineCode parentName="li">{`/payment_initiation/payment/create`}</inlineCode>{` is not supported by the institution.`}</li>
        <li parentName="ul">{`Scheme automatic downgrade failed.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-7"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different payment scheme.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different institution.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_consent_invalid_constraints"
    }}><strong parentName="h4">{`PAYMENT_CONSENT_INVALID_CONSTRAINTS`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_CONSENT_INVALID_CONSTRAINTS' subtitle='The payment consent constraints are missing or not supported by the institution.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-8"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The payment consent constraints specified when calling `}<inlineCode parentName="li">{`/payment_initiation/consent/create`}</inlineCode>{` are not supported by the institution.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-8"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Recreate the consent with different constraints.`}</p>
      </Checkbox>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again with a different institution.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "payment_consent_cancelled"
    }}><strong parentName="h4">{`PAYMENT_CONSENT_CANCELLED`}</strong></h4>
    <ErrorReference type='PAYMENT_ERROR' error='PAYMENT_CONSENT_CANCELLED' subtitle='The payment consent was cancelled.' client mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-9"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`The payment consent was cancelled by the user during the authorisation process.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-9"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`Try again or choose another institution to authorise the payment consent.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "payment_blocked",
        level: 4,
        title: "PAYMENT_BLOCKED",
      },
{
        id: "payment_cancelled",
        level: 4,
        title: "PAYMENT_CANCELLED",
      },
{
        id: "payment_insufficient_funds",
        level: 4,
        title: "PAYMENT_INSUFFICIENT_FUNDS",
      },
{
        id: "payment_invalid_recipient",
        level: 4,
        title: "PAYMENT_INVALID_RECIPIENT",
      },
{
        id: "payment_invalid_reference",
        level: 4,
        title: "PAYMENT_INVALID_REFERENCE",
      },
{
        id: "payment_invalid_schedule",
        level: 4,
        title: "PAYMENT_INVALID_SCHEDULE",
      },
{
        id: "payment_rejected",
        level: 4,
        title: "PAYMENT_REJECTED",
      },
{
        id: "payment_scheme_not_supported",
        level: 4,
        title: "PAYMENT_SCHEME_NOT_SUPPORTED",
      },
{
        id: "payment_consent_invalid_constraints",
        level: 4,
        title: "PAYMENT_CONSENT_INVALID_CONSTRAINTS",
      },
{
        id: "payment_consent_cancelled",
        level: 4,
        title: "PAYMENT_CONSENT_CANCELLED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
